module.exports = __webpack_public_path__ + "img/adulto42.4a41a5bc.jpg";